<template>
    <DescriptionList keep-table class="contact">
        <slot></slot>
        <div class="list-body">
            <template v-if="hotelDetails.name">
                <div class="list-row">
                    <div class="list-item definition">
                        <translate v-if="!isOtherProduct" path="HotelAddress.term.hotel" />
                        <translate v-else path="HotelAddress.term.provider" />
                    </div>

                    <div class="list-item value">
                        <span>{{ hotelDetails.name }}</span>
                    </div>
                </div>
            </template>
            <template v-if="hotelDetails.provider">
                <div class="list-row">
                    <div class="list-item definition">{{ $t('HotelAddress.term.provider') }}</div>
                    <div class="list-item value">
                        <span>{{ hotelDetails.provider }}</span>
                    </div>
                </div>
            </template>
            <template v-if="reseller">
                <div class="list-row">
                    <div class="list-item definition">{{ $t('HotelAddress.term.contact') }}</div>
                    <div class="list-item value">
                        {{ $t('HotelAddress.text.contactReseller', { reseller }) }}
                    </div>
                </div>
            </template>
            <template v-else>
                <template v-if="hotelDetails.street || hotelDetails.zipcode || hotelDetails.city">
                    <div class="list-row">
                        <div class="list-item definition">{{ $t('Generic.address') }}</div>
                        <div class="list-item value">
                            <span class="address">
                                <span v-if="hotelDetails.street">{{ hotelDetails.street }}</span>
                                <span v-if="hotelDetails.zipcode">{{ hotelDetails.zipcode }}</span>
                                <span v-if="hotelDetails.city">{{ hotelDetails.city }}</span>
                            </span>
                        </div>
                    </div>
                </template>
                <template v-if="hotelDetails.provider && hotelDetails.phone">
                    <div class="list-row">
                        <div class="list-item definition">{{ $t('Generic.phone') }}</div>
                        <div class="list-item value">
                            <span>{{ hotelDetails.phone }}</span>
                        </div>
                    </div>
                </template>
                <template v-if="hotelDetails.provider && hotelDetails.fax">
                    <div class="list-row">
                        <div class="list-item definition">{{ $t('Generic.fax') }}</div>
                        <div class="list-item value">
                            <span>{{ hotelDetails.fax }}</span>
                        </div>
                    </div>
                </template>
                <template v-if="hotelDetails.provider && hotelDetails.email">
                    <div class="list-row">
                        <div class="list-item definition">{{ $t('Generic.email') }}</div>
                        <div class="list-item value">
                            <a :href="'mailto:' + hotelDetails.email" :title="hotelDetails.email">{{
                                hotelDetails.email
                            }}</a>
                        </div>
                    </div>
                </template>
                <template v-if="hotelDetails.website">
                    <div class="list-row">
                        <div class="list-item definition">{{ $t('Generic.website') }}</div>
                        <div class="list-item value">
                            <a
                                rel="nofollow noopener"
                                :href="
                                    (hotelDetails.website.indexOf('http') === -1 ? 'https://' : '') +
                                    hotelDetails.website
                                "
                                target="_blank"
                                >{{ hotelDetails.website }}</a
                            >
                        </div>
                    </div>
                </template>
                <template v-if="hotelDetails.termsAndConditionsUrl">
                    <div class="list-row">
                        <div class="list-item definition">{{ $t('Generic.termsAndConditions') }}</div>
                        <div class="list-item value">
                            <a :href="termsAndConditionsUrl" target="_blank">{{ $t('Generic.supplier.terms') }}</a>
                        </div>
                    </div>
                </template>
                <template v-if="hotelDetails.extraInformationUrl">
                    <div class="list-row">
                        <div class="list-item definition">{{ $t('Generic.extraInformationUrl') }}</div>
                        <div class="list-item value">
                            <a :href="extraInformationUrl" target="_blank">{{
                                $t('Generic.supplier.extraInformation')
                            }}</a>
                        </div>
                    </div>
                </template>
            </template>
        </div>
    </DescriptionList>
</template>

<script>
import DescriptionList from '@/components/DescriptionList';

export default {
    name: 'HotelAddress',
    components: {
        DescriptionList
    },
    props: {
        hotelDetails: {
            type: Object,
            required: true
        },
        reseller: {
            type: String
        },
        isOtherProduct: Boolean
    },
    computed: {
        websiteLink: function () {
            if (this.hotelDetails.website) {
                return this.hotelDetails.website.indexOf('http:') !== -1
                    ? this.hotelDetails.website
                    : 'https://' + this.hotelDetails.website;
            }
            return null;
        },
        termsAndConditionsUrl: function () {
            if (this.hotelDetails.termsAndConditionsUrl) {
                return this.hotelDetails.termsAndConditionsUrl.indexOf('http') !== -1
                    ? this.hotelDetails.termsAndConditionsUrl
                    : 'https://' + this.hotelDetails.termsAndConditionsUrl;
            }
            return null;
        },
        extraInformationUrl: function () {
            if (this.hotelDetails.extraInformationUrl) {
                return this.hotelDetails.extraInformationUrl.indexOf('http') !== -1
                    ? this.hotelDetails.extraInformationUrl
                    : 'https://' + this.hotelDetails.extraInformationUrl;
            }
            return null;
        }
    }
};
</script>

<style scoped lang="scss">
.contact {
    .list-item.value {
        line-height: 1.2em;

        span.address span:first-child::after {
            content: ', ';
        }

        span.address span:last-child::after {
            content: '';
        }
    }
}
</style>
